<template>
  <svg
    class="bgy-icon"
    aria-hidden="true"
  >
    <use :xlink:href="iconName"></use>
    <title v-if="title">{{ title }}</title>
  </svg>
</template>

<script>
import '@/assets/css/fonts/iconfont.js';

export default {
  name: 'BgyIcon',
  props: {
    name: {
      type: String,
      require: true // 设置必传
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName() {
      return `#${this.name}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.bgy-icon {
  width: 1em;
  height: 1em;
  fill: currentColor;
  overflow: hidden;
}
</style>
